module.exports = __webpack_public_path__ + "img/icon2.875e811a.png";